var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteKubLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 149,
    viewBox: "0 0 85 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_2034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.672 -21.1337L21.5117 -21.1337L21.5117 0.132812L42.672 0.132813L42.672 -21.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8361 106.467L42.6758 106.467L42.6758 127.733L63.8361 127.733L63.8361 106.467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8361 -21.1337L42.6758 -21.1337L42.6758 0.132812L63.8361 0.132813L63.8361 -21.1337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9963 63.9327L63.8359 63.9327L63.8359 85.1992L84.9963 85.1992L84.9963 63.9327Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0002 21.4005L63.8398 21.4005L63.8398 42.667L85.0002 42.667L85.0002 21.4005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1603 43.0001L2.53601e-07 43.0001L0 64.2666L21.1603 64.2666L21.1603 43.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9963 127.733L63.8359 127.733L63.8359 149L84.9963 149L84.9963 127.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1603 127.147L2.53601e-07 127.147L0 148.413L21.1603 148.413L21.1603 127.147Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9064 84.4337L21.7461 84.4337L21.7461 105.7L42.9064 105.7L42.9064 84.4337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2423 42.713L43.082 42.713L43.082 63.9795L64.2423 63.9795L64.2423 42.713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.304846 127.733L-20.8555 127.733L-20.8555 149L0.304846 149L0.304846 127.733Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0002 0.132883L63.8398 0.132883L63.8398 21.3994L85.0002 21.3994L85.0002 0.132883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8361 0.13386L42.6758 0.13386L42.6758 21.4004L63.8361 21.4004L63.8361 0.13386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1603 7.08242e-05L2.53601e-07 7.05719e-05L0 21.2666L21.1603 21.2666L21.1603 7.08242e-05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0002 85.2003L63.8398 85.2003L63.8398 106.467L85.0002 106.467L85.0002 85.2003Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_2034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 85,
    fill: "white",
    transform: "translate(0 149) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteKubLeft);
export default __webpack_public_path__ + "static/media/white-kub-left.ecc912e69082f020f3f8f4dbd1c06f64.svg";
export { ForwardRef as ReactComponent };